import { render, staticRenderFns } from "./DoubleScroll.vue?vue&type=template&id=9ed34746&"
import script from "./DoubleScroll.vue?vue&type=script&lang=js&"
export * from "./DoubleScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports